import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as l, normalizeClass as d, createElementVNode as s } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconCircleSlashed",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ s("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6 2.174a3.826 3.826 0 0 0-3.036 6.155L8.33 2.964A3.81 3.81 0 0 0 6 2.174Zm3.041.078a4.826 4.826 0 0 0-6.789 6.789l-.931.932a.5.5 0 1 0 .707.707l.931-.932a4.826 4.826 0 0 0 6.789-6.789l.932-.932a.5.5 0 0 0-.707-.707l-.932.932Zm-.005 1.42L3.671 9.035A3.826 3.826 0 0 0 9.036 3.67Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function u(a, h, i, f, p, e) {
  return l(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([e.iconSizeClass, "d-icon d-icon--circle-slashed"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Circle Slashed",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const v = /* @__PURE__ */ n(o, [["render", u]]);
export {
  v as default
};
//# sourceMappingURL=circle-slashed.js.map
